module.exports = __webpack_public_path__ + "img/scroll.f5ac33e3.svg";